import { JsonObject, JsonProperty } from 'json2typescript';
import { UserBoosterType } from '../../enums/users/user-booster-type.enum';

@JsonObject('UserBooster')
export class UserBooster {

  @JsonProperty('type', Number)
  type: UserBoosterType = UserBoosterType.None;

  @JsonProperty('multiplier', Number)
  multiplier: number = 0;

  @JsonProperty('duration', Number)
  duration: number = 0;
}
